import { css, styled } from 'styled-components';

export const TableView = styled.div`
  display: block;

  @container main-content (max-width: ${({ theme }) => theme.screenMD}px) {
    display: none;
  }
`;

export const CardView = styled.div`
  display: none;

  @container main-content (max-width: ${({ theme }) => theme.screenMD}px) {
    display: block;
  }
`;

export const StyledTable = styled.div<{ size?: 'small' | 'middle' | 'large' }>`
  ${({ theme, size }) => css`
    .ant-table {
      background: ${theme.colorBgContainer};
      border-radius: ${theme.borderRadius}px;

      .ant-table-thead > tr > th {
        background: ${theme.colorFillAlter};
        border-bottom: ${theme.lineWidth}px solid ${theme.colorBorder};
        color: ${theme.colorTextHeading};
        font-weight: ${theme.fontWeightStrong};

        &:not(:last-child):not(.ant-table-selection-column):not(
            .ant-table-row-expand-icon-cell
          ):not([colspan])::before {
          background-color: ${theme.colorBorderSecondary};
        }
      }

      .ant-table-tbody > tr > td {
        border-bottom: ${theme.lineWidth}px solid ${theme.colorBorderSecondary};
        transition: background-color ${theme.motionDurationMid}
          ${theme.motionEaseInOut};
      }

      .ant-table-tbody > tr:hover > td {
        background: ${theme.colorFillQuaternary} !important;
      }

      .ant-table-row-selected td {
        background: ${theme.colorFillTertiary} !important;
      }

      ${size === 'small' &&
      `
        .ant-table-tbody > tr > td {
          padding: ${theme.paddingXXS}px ${theme.paddingXS}px;
        }
        .ant-table-thead > tr > th {
          padding: ${theme.paddingXXS}px ${theme.paddingXS}px;
        }
      `}

      ${size === 'large' &&
      `
        .ant-table-tbody > tr > td {
          padding: ${theme.paddingMD}px ${theme.padding}px;
        }
        .ant-table-thead > tr > th {
          padding: ${theme.paddingMD}px ${theme.padding}px;
        }
      `}

      ${(!size || size === 'middle') &&
      `
        .ant-table-tbody > tr > td {
          padding: ${theme.paddingXS}px ${theme.paddingSM}px;
        }
        .ant-table-thead > tr > th {
          padding: ${theme.paddingXS}px ${theme.paddingSM}px;
        }
      `}
    }
  `}

  .ant-table-pagination {
    margin: ${({ theme }) => theme.marginLG}px 0 0 0;

    .ant-pagination-item {
      border-color: ${({ theme }) => theme.colorBorder};

      &:hover {
        border-color: ${({ theme }) => theme.colorPrimary};
      }

      &.ant-pagination-item-active {
        border-color: ${({ theme }) => theme.colorPrimary};
        background-color: ${({ theme }) => theme.colorPrimary};

        a {
          color: ${({ theme }) => theme.colorWhite};
        }
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      border-color: ${({ theme }) => theme.colorBorder};

      &:hover {
        border-color: ${({ theme }) => theme.colorPrimary};
        color: ${({ theme }) => theme.colorPrimary};
      }
    }
  }
`;
